<div class="container text-center">
  @if (gbru && !sso401 && !showForgotPassword) {
    <div class="my-4">
      Your session has expired, please login again to continue using the application.
    </div>
  }
  @if (!sso401) {
    <div
      class="form-group header-snippet"
      [innerHTML]="landingPageHeaderHtmlSnippet">
    </div>
  }
  @if (sso401 && !showForgotPassword) {
    <div>
      <p class="font-weight-bold">
        <span>A problem occurred verifying the user account. Please contact
          <a href="mailto:support@mvsc.com">support&#64;mvsc.com</a> for assistance.</span>
        </p>
      </div>
    }
    @if (uiConfig?.loginType === 'SSO') {
      <div class="form-group sso-button">
        <button class="btn btn-action sso-login-button"
          (click)="login.emit(true)">
          {{ uiConfig?.ssoButtonText }}
        </button>
      </div>
    }
    @if (uiConfig?.loginType === 'LEGACY' && !showForgotPassword) {
      <div
        class="container text-center mt-3 login-form"
        role="modal-body">
        @if (!mfaNoticeEnabled) {
          <reporter-mfa-onboarding class="d-block mb-3"></reporter-mfa-onboarding>
        }
        @if (loginForm !== undefined) {
          <form
            [formGroup]="loginForm"
            (ngSubmit)="submit.emit()"
            autocomplete="off">
            <div class="form-group">
              <label class="required">Username</label>
              <input type="text"
                class="form-control required"
                formControlName="userId"
                placeholder="john.smith">
            </div>
            <div class="form-group mb-1">
              <label class="required">Password</label>
              <input type="password"
                class="form-control required"
                formControlName="password"
                placeholder="Password"
                autocomplete="new-password">
            </div>
            @if (failed) {
              <div
                class="text-danger my-3">
                {{customerMessageError !== '' ? customerMessageError : 'Invalid credentials.'}}
              </div>
            }
            <div>
              <button type="submit"
                class="btn btn-action px-5 mt-4"
                [disabled]="loginForm.invalid">Login
              </button>
            </div>
          </form>
        }
        @if (failed) {
          <div
            class="">
            <button class="btn btn-link px-0" (click)="showForgotPassword = true">
              Forgot Password
            </button>
          </div>
        }
      </div>
    }

    <reporter-forgot-password [hidden]="!showForgotPassword" (onBackToLogin)="showForgotPassword = false">
    </reporter-forgot-password>

    <div class="footer-snippet mt-3"
    [innerHTML]="landingPageFooterHtmlSnippet"></div>
  </div>
